import React from 'react';
import { DateRow, MoreActions, StatusCard, TextRow } from 'components';
import { ClientDiagnosisStatus, Images, PermissionList, RolePermission } from 'utils';

export const GET_DIAGNOSES_ACTION = 'GET_CLIENT_DIAGNOSES';
export const CREATE_DIAGNOSIS_ACTION = 'CREATE_CLIENT_DIAGNOSIS';
export const EDIT_DIAGNOSIS_ACTION = 'EDIT_CLIENT_DIAGNOSIS';
export const SET_PRIMARY_DIAGNOSIS_ACTION = 'SET_PRIMARY_CLIENT_DIAGNOSIS';
export const DELETE_DIAGNOSIS_ACTION = 'DELETE_CLIENT_DIAGNOSIS';

export const diagnosisActionNames = {
    EDIT: 'edit',
    MAKE_PRIMARY: 'makePrimary',
    REMOVE: 'remove',
};

export const canManageDiagnoses = () => RolePermission([PermissionList.CLIENT_DIAGNOSIS_MANAGE?.code]);

/** Built per render — the Action column depends on the signed-in user's permissions. */
export const diagnosesHead = () => [
    { name: 'code', title: 'Code', custom: false, noSearch: true, width: '120px' },
    { name: 'description', title: 'Description', custom: false, noSearch: true },
    { name: 'isPrimary', title: 'Primary', custom: false, noSearch: true, width: '150px' },
    { name: 'startDate', title: 'Start Date', custom: false, noSearch: true, width: '140px' },
    { name: 'endDate', title: 'End Date', custom: false, noSearch: true, width: '140px' },
    { name: 'status', title: 'Status', custom: false, noSearch: true, width: '130px' },
    canManageDiagnoses() && { name: 'action', title: 'Action', custom: false, disabled: true, noSearch: true, width: '80px' },
].filter(Boolean);

export const diagnosesBody = () => [
    {
        rowText: (item) => (
            <div className="flex-align-center" style={{ gap: 8 }}>
                <TextRow name={item?.code} fontWeight={600} />
                {/* The code left the ICD-10-CM set in a yearly update: payers reject it — end-date it and add the current code. */}
                {item?.isRetired && <span className="diagnosis-retired-badge">Retired</span>}
            </div>
        ),
    },
    { rowText: (item) => <TextRow name={item?.description || '—'} /> },
    {
        // Design: star badge for the primary, plain "Make primary" for other active / upcoming rows, blank otherwise
        button: (cb, item) =>
            item?.isPrimary ? (
                <span className="diagnosis-primary-badge">
                    <img src={Images.starVector} alt="" />
                    Primary
                </span>
            ) : canManageDiagnoses() && item?.status !== ClientDiagnosisStatus.INACTIVE ? (
                <button type="button" className="diagnosis-make-primary-btn" onClick={() => cb(diagnosisActionNames.MAKE_PRIMARY)}>
                    Make primary
                </button>
            ) : null,
        notClickable: true,
    },
    { rowText: (item) => <DateRow date={item?.startDate} /> },
    { rowText: (item) => (item?.endDate ? <DateRow date={item?.endDate} /> : '—') },
    { rowText: (item) => <StatusCard status={item?.status} /> },
    canManageDiagnoses() && {
        button: (cb, item) => (
            <MoreActions
                item={item}
                buttonsList={[
                    { text: 'Edit', icon: Images.edit, actionName: diagnosisActionNames.EDIT },
                    // A code that reached a claim stays on record — the user end-dates it instead.
                    !item?.usedOnClaim && {
                        text: 'Remove',
                        icon: Images.redTrash,
                        actionName: diagnosisActionNames.REMOVE,
                        originalColor: true,
                    },
                ]}
                handleAction={(e, it, name) => cb(name)}
            />
        ),
        notClickable: true,
    },
].filter(Boolean);

export const diagnosesNotYet = {
    title: 'No Diagnoses Yet',
    subTitle: 'Add the client’s diagnoses so appointments and claims carry the right codes.',
    image: Images.noContact,
};
